<script lang="ts">
	import {page as pp} from '$app/stores'
	// console.log($pp.url)
	export let count = 1, pageNo = 1;

	let regex = /page=\d+(&|$)/g

	let query=$pp.url.search.replaceAll(regex,'').replace('?','')

	$:newQuery($pp.url.search)

	function newQuery(params:string) {
		query=$pp.url.search.replaceAll(regex,'').replace('?','')
	}
</script>

{#if count <= 10 && count>0}
	{#each Array(count) as _, i}
		<a
			href="?page={i + 1}{query?'&'+query:''}"
			class="border rounded-md border-primary {pageNo==i+1?'text-white bg-primary':''} text-gray-700 mr-2 font-medium text-lg px-2 py-1"
		>
			{i + 1}
		</a>
	{/each}
{:else if count >10}
	<a
		href="?page=1{query?'&'+query:''}"
		class="border rounded-md border-primary {pageNo==1?'text-white bg-primary':''} text-gray-700 mr-2 font-medium text-lg px-2 py-1"
	>
		1
	</a>
	{#if pageNo <= 2}
		<a
			href="?page=2{query?'&'+query:''}"
			class="border rounded-md border-primary {pageNo==2?'text-white bg-primary':''} text-gray-700 mr-2 font-medium text-lg px-2 py-1"
		>
			2
		</a>
		<a
		href="?page=3{query?'&'+query:''}"
		class="border rounded-md border-primary {pageNo==3?'text-white bg-primary':''} text-gray-700 mr-2 font-medium text-lg px-2 py-1"
	>
		3
	</a>
		<div class="text-gray-700 mr-2 font-medium text-lg px-2 pt-2">...</div>
	{/if}
	{#if pageNo >= 3 && pageNo <= count}
		<div class="text-gray-700 mr-2 font-medium text-lg px-1 pt-2 {pageNo-2==1?'hidden':''}">...</div>
		<a
			href="?page={pageNo - 1}{query?'&'+query:''}"
			class="border rounded-md border-primary {pageNo==pageNo - 1?'text-white bg-primary':''} text-gray-700 mr-2 font-medium text-lg px-2 py-1"
		>
			{pageNo - 1}
		</a>
		{#if pageNo != count}
			<a
				href="?page={pageNo}{query?'&'+query:''}"
				class="border rounded-md border-primary {pageNo==pageNo?'text-white bg-primary':''} text-gray-700 mr-2 font-medium text-lg px-2 py-1"
			>
				{pageNo}
			</a>
			{#if pageNo!= count - 1}
				<a
					href="?page={pageNo + 1}{query?'&'+query:''}"
					class="border rounded-md border-primary {pageNo==pageNo + 1?'text-white bg-primary':''} text-gray-700 mr-2 font-medium text-lg px-2 py-1"
				>
					{pageNo + 1}
				</a>
				<div class="text-gray-700 mr-2 font-medium text-lg px-1 pt-2 {pageNo+1==count-1?'hidden':''}">...</div>
			{/if}
		{/if}
	{/if}
	<a
		href="?page={count}{query?'&'+query:''}"
		class="border rounded-md border-primary {pageNo==count?'text-white bg-primary':''} text-gray-700 mr-2 font-medium text-lg px-2 py-1"
	>
		{count}
	</a>
{/if}
